import { Module } from "wrapper6";

var $ = jQuery;

export default class Filters extends Module {
	
	ready() {
		
		/********************************************
		 * SHARED VARS
		 ********************************************/
		const LOADER = $('#loader-overlay');

		/********************************************
		 * 
		 * CASES FILTER SLIDER
		 * 
		 ********************************************/

		// Consts
    	const CASES_TOGGLE = $('#filter-cases a');
    	const CASES_SELECT = $('#cases-select');
		const CASES_DEST = $('#cases-destination');

		// Lets
		let cases_cat = $('#filter-cases a.active').attr('data-id');
		let cases_business = $( "#cases-select option:selected" ).val();

		// Click on filter toggle
		CASES_TOGGLE.on('click', function() {

			// Update category-id and reset pagenumber
			cases_cat = $(this).attr('data-id');
			
			// Run ajax request
			getCases(); 
		});

		// Click on filter toggle
		CASES_SELECT.on('change', function() {

			// Update category-id and reset pagenumber
			cases_business = $( "#cases-select option:selected" ).val();
			
			// Run ajax request
			getCases(); 
		});

		// Ajax request function
		function getCases() {

			// Show loader
			LOADER.addClass('show');

			// Set ajax data
			let data = {
				'action': 'filter_cases',
				'cat': cases_cat,
				'business': cases_business,
				'url': window.location.href,
			};

			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, function(response) {			

				if (response != 0) {

					// Set toggle to active, remove from siblings
					$('#filter-cases a[data-id='+cases_cat+']').addClass('active').siblings().removeClass('active');

					// Post response
					CASES_DEST.html(response.cases);			
					
					// Hide loader
					LOADER.removeClass('show');
					
				}
			});
		}

		/********************************************
		 * CASES FILTER SLIDER END
		 ********************************************/

		 /********************************************
		 * 
		 * EMPLOYEES FILTER SLIDER
		 * 
		 ********************************************/

		// Consts
    	const EMPLOYEES_TOGGLE = $('#filter-employees li');
		const EMPLOYEES_DEST = $('#employees-destination');

		// Lets
		let employees_cat = $('#filter-employees li.active').attr('data-term-id');

		// Click on filter toggle
		EMPLOYEES_TOGGLE.on('click', function() {

			// Update category-id and reset pagenumber
			employees_cat = $(this).attr('data-term-id');
			
			// Run ajax request
			getEmployees(); 
		});

		// Ajax request function
		function getEmployees() {

			// Show loader
			LOADER.addClass('show');

			// Set ajax data
			let data = {
				'action': 'load_employees',
				'term_id': employees_cat,
				'url': window.location.href,
			};

			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, function(response) {			

				if (response != 0) {

					// Set toggle to active, remove from siblings
					$('#filter-employees li[data-term-id='+employees_cat+']').addClass('active').siblings().removeClass('active');

					// Post response
					EMPLOYEES_DEST.html(response.markup);			
					
					// Hide loader
					LOADER.removeClass('show');
					
				}
			});
		}

		/********************************************
		 * EMPLOYEES FILTER SLIDER END
		 ********************************************/
		 
		 /********************************************
		 * 
		 * NEWS FILTER
		 * 
		 ********************************************/

		// Consts
    	const NEWS_TOGGLE = $('#filter-news li');
		const NEWS_DEST = $('#news-destination');
		const NEWS_PAGINATION = $('.news-archive__pagination');
		
		// Lets
		let news_cat = $('#filter-news li.active').attr('data-cat');
		let pagenumber = '1';
		
		const PAGINATION_ITEMS = $('.news-archive__pagination .mtt-pagination__toggle');
		if (PAGINATION_ITEMS.length > 0) {
            for (let i = 0; i < PAGINATION_ITEMS.length; i++) {
                const PAGINATION_ITEM = PAGINATION_ITEMS[i];
                PAGINATION_ITEM.addEventListener('click', (e) => {
                    e.preventDefault();
                    pagenumber = PAGINATION_ITEM.getAttribute('data-page');
                    getNews();
                });
            }
        }

		// Click on filter toggle
		NEWS_TOGGLE.on('click', function() {

			// Update category-id and reset pagenumber
			news_cat = $(this).attr('data-cat');
			
			// Run ajax request
			pagenumber = 1
			getNews(); 
		});

		// Ajax request function
		function getNews() {

			// Show loader
			LOADER.addClass('show');

			// Set ajax data
			let data = {
				'action': 'filter_news',
				'cat': news_cat,
				'pagenumber': pagenumber,
				'url': window.location.href,
			};

			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, function(response) {			

				if (response != 0) {

					// Set toggle to active, remove from siblings
					$('#filter-news li[data-cat='+news_cat+']').addClass('active').siblings().removeClass('active');

					// Post response
					NEWS_DEST.html(response.markup);			
					NEWS_PAGINATION.html(response.pagination);		
					
					const PAGINATION_ITEMS = $('.news-archive__pagination .mtt-pagination__toggle');
					if (PAGINATION_ITEMS.length > 0) {
						for (let i = 0; i < PAGINATION_ITEMS.length; i++) {
							const PAGINATION_ITEM = PAGINATION_ITEMS[i];
							PAGINATION_ITEM.addEventListener('click', (e) => {
								e.preventDefault();
								pagenumber = PAGINATION_ITEM.getAttribute('data-page');
								getNews();
							});
						}
					}
					
					// Hide loader
					LOADER.removeClass('show');
					
				}
			});
		}

		/********************************************
		 * NEWS FILTER END
		 ********************************************/
         
    }
}